import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'index',
            component: () => import('@/views/index/index'),
        },
        {
            path: '/goods',
            name: 'goods',
            component: () => import('@/views/goods/index'),
        },
        {
            path: '/order',
            name: 'order',
            component: () => import('@/views/order/index'),
        },
        {
            path: '/contributionDetail',
            name: 'contributionDetail',
            component: () => import('@/views/contributionDetail/index'),
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js